//Если ты зашел сюда чтобы узнать ответы, штош, я просто позлопаю, молодец ;)
export const gridData = [
  [null, null, null, null, null, null, null, "L", "O", "A", "D", "E", "R"],
  [null, null, null, null, null, null, null, null, "P", null, null, null, null],
  [null, null, null, null, null, null, null, null, "A", null, null, null, null],
  [null, null, null, null, null, null, null, null, "C", null, null, null, null],
  [null, "K", null, "T", "R", "A", "N", "S", "I", "T", "I", "O", "N"],
  [null, "E", null, "I", null, null, null, null, "T", null, null, null, null],
  [null, "Y", null, "M", null, null, null, null, "Y", null, null, null, null],
  [null, "F", null, "I", null, null, null, null, null, null, null, null, null],
  ["T", "R", "A", "N", "S", "I", "T", "I", "O", "N", "E", "N","D"],
  [null, "A", null, "G", null, null, null, null, null, null, null, null, null],
  [null, "M", null, "F", null, null, null, null, null, null, null, null, null],
  [null, "E", null, "U", null, "J", null, null, null, null, null, null, null],
  [null, "S", null, "N", null, "A", null, null, null, null, null, null, null],
  [null, null, null, "C", null, "V", null, null, null, null, null, null, null],
  [null, null, null, "T", "R", "A", "N", "S", "F", "O", "R", "M", null],
  [null, null, null, "I", null, "S", null, null, null, null, null, null, null],
  [null, null, null, "O", null, "C", null, null, null, null, null, null, null],
  [null, null, null, "N", null, "R", null, null, null, null, null, null, null],
  [null, null, null, null, null, "I", "N", "F", "I", "N", "I", "T", "E"],
  [null, null, null, null, null, "P", null, null, null, null, null, null, null],
  [null, null, null, null, null, "T", null, null, null, null, null, null, null]
];

export const words = {
  horizontal: [
    {
      word: "LOADER",
      clue: "Анимированный элемент, который показывается во время загрузки данных с сервера",
      row: 0,
      col: 7
    },
    {
      word: "TRANSITION",
      clue: "CSS свойство, которое позволяет плавно анимировать изменение значений других свойств",
      row: 4,
      col: 3
    },
    {
      word: "TRANSITIONEND",
      clue: "JavaScript событие, которое срабатывает по окончанию CSS transition",
      row: 8,
      col: 0
    },
    {
      word: "TRANSFORM",
      clue: "CSS свойство, которое позволяет вращать, масштабировать, наклонять или перемещать элемент",
      row: 14,
      col: 3
    },
    {
      word: "INFINITE",
      clue: "Значение animation-iteration-count, которое заставляет анимацию повторяться бесконечно",
      row: 18,
      col: 5
    }
  ],
  vertical: [
    {
      word: "OPACITY",
      clue: "CSS свойство, которое управляет прозрачностью элемента (часто анимируется)",
      row: 0,
      col: 8
    },
    {
      word: "KEYFRAMES",
      clue: "Правило @, которое определяет промежуточные шаги анимации",
      row: 4,
      col: 1
    },
    {
      word: "TIMINGFUNCTION",
      clue: "Свойство transition или animation, определяющее скорость анимации в разные моменты времени",
      row: 4,
      col: 3
    },
    {
      word: "JAVASCRIPT",
      clue: "Язык программирования, который можно использовать для создания сложных анимаций",
      row: 11,
      col: 5
    }
  ]
};